import  Vue  from  "vue";

Vue.filter('abv', function (value) {
  if (!value) return '';
  value = Math.round(value * 10) / 10;
  return value + "%"
});

Vue.filter('grainPercentage', function (value) {
  if (!value) return '';
  value = Math.round(value);
  return value + "%"
});

Vue.filter('percentage', function (value) {
  if (!value) return '';

  return value + "%";
});

Vue.filter('grainWeight', function (value) {
  if (!value) return '';
  return value[1].val  + " " +  value[1].unit;
});
Vue.filter('grainWeightRaw', function (value) {
  if (!value) return '';
  return value[1].val;
});

Vue.filter('hopsWeight', function (value) {
  if (!value) return '';
  return value[0].val + " " + value[0].unit;
});

Vue.filter('hopsWeightRaw', function (value) {
  if (!value) return '';
  return value[0].val;
});

Vue.filter('otherIngredientWeightRaw', function (value) {
  if (!value) return '';
  return value[0].val;
});

Vue.filter('otherIngredientWeight', function (value) {
  if (!value) return '';
  return value[0].val + " " + value[0].unit;
});

Vue.filter('hopsTimeRaw', function (value) {
  if (!value) return '';
  return value[0].val;
});

Vue.filter('dryHopsTimeRaw', function (value) {
  if (!value) return '';
  return value[2].val;
});

Vue.filter('hopsTime', function (value) {
  if (!value) return '';
  return value[0].val + value[0].unit;
});

Vue.filter('otherTime', function (value) {
  if (!value) return '';
  return value[0].val;
});

Vue.filter('sg', function (value) {
  if (!value) return '';
  value = parseFloat(value);
  value = value.toFixed(3);
  return value;
});

Vue.filter('toFloat', function (value) {
  value = parseFloat(value);
  return value;
});

Vue.filter('toInt', function (value) {
  value = parseInt(value);
  return value;
});

Vue.filter('joinedList', function (value) {
  if (!value) return '';
  value = _(value).compact().join(' | ');
  return value;
});

Vue.filter('joinedList2', function (value) {
  if (!value) return '';
  value = _(value).compact().join(' / ');
  return value;
});

Vue.filter('month', function (value) {
  let months = {
    0: 'Jan',
    1: 'Feb',
    2: 'Mar',
    3: 'Apr',
    4: 'May',
    5: 'Jun',
    6: 'Jul',
    7: 'Aug',
    8: 'Sep',
    9: 'Oct',
    10: 'Nov',
    11: 'Dec'
  };
  if (!value) return '';
  value = months[parseInt(value)];
  return value;
});

Vue.filter('day', function (value) {
  if (!value) {
    return '0';
  }

  if (String(value).length === 1) {
    return "0" + value;
  } else {

    return value;
  }
});

Vue.filter('temp', function (value) {
  if (!value) {
    return '0';
  }
    return value[1].val + "°" + value[1].unit;
});

Vue.filter('none', function (value) {
  if (!value) {
    return '—';
  } else {
    return value;
  }
});

Vue.filter('volume', function (value) {
  if (!value) return '';
  return value[1].val;
});

Vue.filter('volumeUnit', function (value) {
  if (!value) {
    return '';
  } else {
    return value[1].unit;
  }
});

Vue.filter('timestampToDateTime', function (value) {
  if (!value) {
    return '';
  }

  let date = new Date(value);
  return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
});

Vue.filter('parseMonth', function (datetime) {
  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  return monthNames[datetime.getMonth()] + ' ' + datetime.getFullYear();
});

Vue.filter('timeAgo', function (value) {
    let date = new Date(value);
    let seconds = Math.floor((new Date() - date) / 1000);
    let interval = Math.floor(seconds / 31536000);

    if (interval > 1) {
      // return interval + " years";
      return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    }
    interval = Math.floor(seconds / 2592000);
    if (interval > 1) {
      // return interval + " months";
      return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    }
    interval = Math.floor(seconds / 86400);
    if (interval > 1) {
      return interval + " days ago";
    }
    interval = Math.floor(seconds / 3600);
    if (interval > 1) {
      return interval + " hours ago";
    }
    interval = Math.floor(seconds / 60);
    if (interval > 1) {
      return interval + " minutes ago";
    }
    return Math.floor(seconds) + " seconds ago";
});
